import { BarChart2, Home, Shield } from "react-feather";
import {
  FaCity,
  FaDatabase,
  FaDesktop,
  FaGlobeAsia,
  FaRoute,
  FaServer,
  FaSitemap,
} from "react-icons/fa";
import { FiNavigation, FiUsers } from "react-icons/fi";
import { BiChat } from "react-icons/bi";
import { SiGooglechat } from "react-icons/si";

export default [
  {
    header: "Main",
  },
  {
    id: "view-dashboard",
    acl: "view-dashboard",
    title: "Dashboard",
    icon: <Home size={20} />,
    navLink: "/admin/dashboard",
    public: true,
  },
  {
    id: "view-statistics",
    acl: "view-statistics",
    title: "Statistics",
    icon: <BarChart2 size={20} />,
    children: [
      {
        id: "statistics_per_data",
        acl: "view-statistics",
        title: "Per Date",
        icon: <FaDatabase size={20} />,
        navLink: "/admin/date/statistics",
      },
      {
        id: "statistics_per_country",
        acl: "view-statistics",
        title: "Country",
        icon: <FaGlobeAsia size={12} />,
        navLink: "/admin/country/statistics",
      },
      {
        id: "statistics_per_city",
        acl: "view-statistics",
        title: "City",
        icon: <FaCity size={12} />,
        navLink: "/admin/city/statistics",
      },
      {
        id: "statistics_per_operatinSystem",
        acl: "view-statistics",
        title: "Operating System",
        icon: <FaDesktop size={12} />,
        navLink: "/admin/operatinSystem/statistics",
      },
      {
        id: "statistics_per_browser",
        acl: "view-statistics",
        title: "Navigator",
        icon: <FiNavigation size={12} />,
        navLink: "/admin/browser/statistics",
      },
      // {
      //   id: "statistics_per_reachWay",
      //   acl: "view-statistics",
      //   title: "Reach Way",
      //   icon: <FaRoute size={12} />,
      //   navLink: "/admin/reachWay/statistics",
      // },
      // {
      //   id: "statistics_per_hostname",
      //   acl: "view-statistics",
      //   title: "Hostname",
      //   icon: <FaServer size={12} />,
      //   navLink: "/admin/hostname/statistics",
      // },
      // {
      //   id: "statistics_per_organisation",
      //   acl: "view-statistics",
      //   title: "Organisation",
      //   icon: <FaSitemap size={12} />,
      //   navLink: "/admin/organisation/statistics",
      // },
    ],
  },
  {
    id: "access_control",
    acl: "access_control",
    title: "Access Control",
    icon: <Shield size={20} />,
    children: [
      {
        id: "view-users",
        acl: "view-users",
        title: "Users",
        icon: <FiUsers size={20} />,
        navLink: "/admin/users/list",
      },
      {
        id: "view-roles",
        acl: "view-roles",
        title: "Roles",
        icon: <FaDatabase size={20} />,
        navLink: "/admin/roles",
      },
      {
        id: "view-permissions",
        acl: "view-permissions",
        title: "Permissions",
        icon: <FaGlobeAsia size={12} />,
        navLink: "/admin/permission",
      },
      {
        id: "view-modals",
        acl: "modals",
        title: "Modals",
        icon: <FaGlobeAsia size={12} />,
        navLink: "/admin/modals",
      },
    ],
  },
  {
    id: "chat",
    acl: "chat",
    title: "Chat",
    icon: <BiChat size={20} />,
    children: [
      {
        id: "public-chat",
        acl: "public-chat",
        title: "Public",
        icon: <SiGooglechat size={20} />,
        navLink: "/admin/chat/public",
      },
      {
        id: "private-chat",
        acl: "private-chat",
        title: "Private",
        icon: <SiGooglechat size={20} />,
        navLink: "/admin/chat/private",
      },
    ],
  },
  {
    id: "view-stuff-users-id",
    acl: "view-stuff-users-id",
    title: "Stuff",
    icon: <FiUsers size={20} />,
    children: [],
  },
];
